import React, { useState } from "react";

import useRequest from 'hooks/useRequest';

import gota from 'assets/images/gota.png';

import "./styles.scss";

const Situacion = ({ situacion, situacionCompleta }) => {
    return <p className={`estado ${situacion}`} >{situacionCompleta}</p>
}

export default Situacion;














